export const GET_LIST_REFERRAL_SOURCE = "GET_LIST_REFERRAL_SOURCE";
export const GET_LIST_REFERRAL_SOURCE_SUCCESS = "GET_LIST_REFERRAL_SOURCE_SUCCESS";
export const GET_LIST_REFERRAL_SOURCE_ERROR = "GET_LIST_REFERRAL_SOURCE_ERROR";
export const CLEAR_LIST_REFERRAL_SOURCE = 'CLEAR_LIST_REFERRAL_SOURCE';

export const CREATE_REFERRAL_SOURCE = "CREATE_REFERRAL_SOURCE";
export const CREATE_REFERRAL_SOURCE_SUCCESS = "CREATE_REFERRAL_SOURCE_SUCCESS";
export const CREATE_REFERRAL_SOURCE_CLEAR = "CREATE_REFERRAL_SOURCE_CLEAR";
export const CREATE_REFERRAL_SOURCE_ERROR = "CREATE_REFERRAL_SOURCE_ERROR";

export const GET_REFERRAL_SOURCE = "GET_REFERRAL_SOURCE";
export const GET_REFERRAL_SOURCE_SUCCESS = "GET_REFERRAL_SOURCE_SUCCESS";
export const GET_REFERRAL_SOURCE_CLEAR = "GET_REFERRAL_SOURCE_CLEAR";
export const GET_REFERRAL_SOURCE_ERROR = "GET_REFERRAL_SOURCE_ERROR";

export const UPDATE_REFERRAL_SOURCE = "UPDATE_REFERRAL_SOURCE";
export const UPDATE_REFERRAL_SOURCE_SUCCESS = "UPDATE_REFERRAL_SOURCE_SUCCESS";
export const UPDATE_REFERRAL_SOURCE_CLEAR = "UPDATE_REFERRAL_SOURCE_CLEAR";
export const UPDATE_REFERRAL_SOURCE_ERROR = "UPDATE_REFERRAL_SOURCE_ERROR";

// export const REMOVE_BUNDLE = "REMOVE_BUNDLE";
// export const REMOVE_BUNDLE_SUCCESS = "REMOVE_BUNDLE_SUCCESS";
// export const REMOVE_BUNDLE_CLEAR = "REMOVE_BUNDLE_CLEAR";
// export const REMOVE_BUNDLE_ERROR = "REMOVE_COURSE_ERROR";

// export const CHANGE_BUNDLE_STATUS = "CHANGE_BUNDLE_STATUS";
// export const CHANGE_BUNDLE_STATUS_SUCCESS = "CHANGE_BUNDLE_STATUS_SUCCESS";
// export const CHANGE_BUNDLE_STATUS_ERROR = "CHANGE_BUNDLE_STATUS_ERROR";
// export const CHANGE_BUNDLE_STATUS_CLEAR = "CHANGE_BUNDLE_STATUS_CLEAR";

export const GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE = "GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE";
export const GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_CLEAR = "GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_CLEAR";
export const GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_SUCCESS = "GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_SUCCESS";
export const GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_ERROR = "GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_ERROR";